// Module
var code = "<p>{{'variable_freemium_resendInvitation' | translate:{ username: username } }}</p>";
// Exports
var _module_exports =code;;
var path = '/components-superadmin/freemium/resend.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;